export var getAssignmentErrorMessage = function getAssignmentErrorMessage(value) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var error = value && typeof value === 'object' && 'error' in value ? value.error : value;
  if (typeof error === 'string') return error;
  if (error && typeof error === 'object' && 'message' in error) return String(error.message);
  return fallback;
};